"use client";

import { Icon } from "@iconify/react";
import Link from "next/link";
import { useEffect, useState } from "react";
import useAuthInfo from "@/store/auth";

export default function BankAccountBanner() {
  const verificationStatus = useAuthInfo((state) => state.isVerified);
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    const hydrateAuth = async () => {
      await useAuthInfo.persist.rehydrate();
      setIsHydrated(true);
    };

    hydrateAuth();
  }, []);

  if (
    !isHydrated ||
    verificationStatus === null ||
    verificationStatus === "Success" ||
    verificationStatus === "Pending"
  ) {
    return null;
  }

  const hasFailed = verificationStatus === "Failed";

  return (
    <div className="w-full border-b border-gray-200 bg-gray-50 px-4 py-3 dark:border-gray-600 dark:bg-gray-700">
      <div className="mx-auto flex max-w-7xl items-center justify-center">
        <p className="flex items-center text-sm font-normal text-gray-600 dark:text-gray-300">
          <span className="me-3 inline-flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-gray-200 p-1 dark:bg-gray-600">
            <Icon
              aria-hidden="true"
              className="text-2xl"
              icon="heroicons-outline:credit-card"
            />
          </span>
          <span>
            {hasFailed
              ? "We could not verify your banking details. Please review them and try again so you can receive your earnings from campaigns and referrals. "
              : "Link your bank account so you can get paid for campaigns and referrals. "}
            <Link
              href="/user-verification"
              className="inline font-medium text-blue-600 underline decoration-blue-600 underline-offset-2 hover:no-underline dark:text-blue-500 dark:decoration-blue-500"
            >
              {hasFailed ? "Retry Bank Account Verification" : "Link Bank Account"}
            </Link>
          </span>
        </p>
      </div>
    </div>
  );
}